import { Link } from "react-router-dom";
import { TownEyeLogo } from "@/components/TownEyeLogo";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen" style={{ background: "var(--te-bg)" }}>
      <header className="te-glass-header sticky top-0 z-40">
        <div className="max-w-3xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
          <Link to="/" data-testid="privacy-logo-link"><TownEyeLogo /></Link>
          <Link to="/" className="text-sm font-medium text-[var(--te-primary)] hover:underline" data-testid="privacy-back-link">Back home</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="te-eyebrow mb-3">Legal</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-[var(--te-text)]">Privacy Policy</h1>
        <p className="text-sm text-[var(--te-text-muted)] mt-2">Last updated: February 2026</p>

        <article className="max-w-none mt-10 space-y-6 text-[var(--te-text)] leading-relaxed">
          <section>
            <h2 className="font-heading text-2xl font-semibold mt-8 mb-3">1. What we collect</h2>
            <p>When you sign up we collect your name, email (or phone number), and any optional info you provide such as city, bio, profile photo, and username. When you post we store the content, images, and approximate location (if you choose to share it).</p>
          </section>
          <section>
            <h2 className="font-heading text-2xl font-semibold mt-8 mb-3">2. How we use it</h2>
            <p>Your data powers the service: authentication, your feed, notifications, search, and admin moderation. We do not sell your personal data to third parties.</p>
          </section>
          <section>
            <h2 className="font-heading text-2xl font-semibold mt-8 mb-3">3. Cookies</h2>
            <p>We use httpOnly cookies and a localStorage token to keep you signed in. We do not run advertising trackers.</p>
          </section>
          <section>
            <h2 className="font-heading text-2xl font-semibold mt-8 mb-3">4. Security</h2>
            <p>Passwords are hashed with bcrypt. Tokens are signed with a private secret and expire automatically. We rate-limit sign-ups and logins to deter abuse.</p>
          </section>
          <section>
            <h2 className="font-heading text-2xl font-semibold mt-8 mb-3">5. Your rights</h2>
            <p>You can edit or delete your profile any time from <Link to="/dashboard" className="text-[var(--te-primary)] hover:underline">your dashboard</Link>. To delete your account entirely, contact hello@towneye.app.</p>
          </section>
          <section>
            <h2 className="font-heading text-2xl font-semibold mt-8 mb-3">6. Children</h2>
            <p>TownEye is not intended for children under 13. If you believe a child has signed up, please notify us and we will remove the account.</p>
          </section>
          <section>
            <h2 className="font-heading text-2xl font-semibold mt-8 mb-3">7. Contact</h2>
            <p>Privacy questions: privacy@towneye.app</p>
          </section>
        </article>

        <div className="mt-12 pt-8 border-t border-[var(--te-divider)] flex items-center justify-between text-sm">
          <Link to="/terms" className="text-[var(--te-primary)] hover:underline font-medium" data-testid="privacy-link-terms">Read Terms of Service →</Link>
          <Link to="/register" className="te-btn-primary py-2 px-5 text-sm" data-testid="privacy-cta-signup">Create account</Link>
        </div>
      </main>
    </div>
  );
}
